import React from 'react';
import { motion } from 'framer-motion';
import { Github, Linkedin, Mail, FileText } from 'lucide-react';
import { ContactLink } from '../types';
import './Contact.css';

const Contact: React.FC = () => {
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        delayChildren: 0.3,
        staggerChildren: 0.2
      }
    }
  };

  const itemVariants = {
    hidden: { y: 20, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1
    }
  };

  const contactLinks: ContactLink[] = [
    {
      href: `${process.env.PUBLIC_URL}/resume/Wasif_Sarwar_Siddique_Resume.pdf`,
      icon: FileText,
      label: "Download Resume"
    },
    {
      href: "mailto:wasif.sarwar9@gmail.com",
      icon: Mail,
      label: "wasif.sarwar9@gmail.com"
    },
    {
      href: "https://linkedin.com/in/wasifsiddique",
      icon: Linkedin,
      label: "LinkedIn Profile"
    },
    {
      href: "https://github.com/wasifsarwar",
      icon: Github,
      label: "GitHub Projects"
    }
  ];

  return (
    <section id="contact" className="contact">
      <motion.div
        className="container"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true }}
        variants={containerVariants}
      >
        <motion.h2 variants={itemVariants}>Let's Work Together</motion.h2>
        <motion.p variants={itemVariants} className="contact-description">
          I'm looking for backend engineering roles where I can solve real world problems at scale. If you're working on something challenging, let's talk!
        </motion.p>
        <motion.div className="contact-links" variants={containerVariants}>
          {contactLinks.map((link, index) => {
            const IconComponent = link.icon;
            const isResume = link.label === "Download Resume";
            const isExternal = link.href.startsWith('http');

            return (
              <motion.a
                key={index}
                href={link.href}
                className="contact-link"
                variants={itemVariants}
                whileHover={{ scale: 1.05 }}
                {...(isResume && { download: true })}
                {...(isExternal && { target: "_blank", rel: "noopener noreferrer" })}
              >
                <IconComponent size={20} />
                {link.label}
              </motion.a>
            );
          })}
        </motion.div>
      </motion.div>
    </section>
  );
};

export default Contact;